import { AssetRunDryInfo } from "@hydrologiq/gql/graphql"
import Figure, { FigureProps } from "./Figure"
import FigureContent from "./FigureContent"
import { Link } from "@hydrologiq/shared/components/Link"
import { formatRunDryMinutes } from "@hydrologiq/shared/asset/attributes/RunDry"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

export interface RefuelNeededInProps extends FigureProps {
  minutes?: number
  location?: string
  system?: string
  systemId?: string
  granularity?: "hours" | "days"
  customer?: string
  site?: string
  info?: AssetRunDryInfo
}

const RefuelNeededIn = ({ minutes, location, system, systemId, customer, site, granularity = "hours", ...rest }: RefuelNeededInProps) => {

  const systemLink = system ? (
    systemId ? (
      <Link href={`/systems/${systemId}`} fontSize="xs" tooltip={!!system} truncate>{system}</Link>
    ) : (
      <FigureContent.Label>{system}</FigureContent.Label>
    )
  ) : undefined

  return (
    <Figure {...rest} isPlaceholder={minutes === undefined} compact={isCompactFigure("summary")}>
      <FigureContent.Root>
        <FigureContent.SubText link={systemLink}>estimated</FigureContent.SubText>
        <FigureContent.Value>
          {typeof minutes === "number" ? formatRunDryMinutes(minutes, true) : "pending"}
        </FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default RefuelNeededIn